var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 60,
    viewBox: "0 0 98 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0692 3.03643C15.757 1.3486 18.0462 0.400391 20.4331 0.400391H89.0008C93.9713 0.400391 98.0008 4.42983 98.0008 9.40039V50.8004C98.0008 55.771 93.9713 59.8004 89.0008 59.8004H9.80078C4.83022 59.8004 0.800781 55.771 0.800781 50.8004V19.7113C0.800781 17.2297 1.82542 14.8583 3.6325 13.1575L8.99727 8.10832L14.0692 3.03643ZM20.4331 4.00039C19.0009 4.00039 17.6274 4.56932 16.6147 5.58201L11.5043 10.6925L6.09981 15.779C5.01556 16.7995 4.40078 18.2224 4.40078 19.7113V50.8004C4.40078 53.7827 6.81844 56.2004 9.80078 56.2004H89.0008C91.9831 56.2004 94.4008 53.7827 94.4008 50.8004V9.40039C94.4008 6.41805 91.9831 4.00039 89.0008 4.00039H20.4331Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.1792 10.1192C39.0341 9.0932 40.3006 8.5 41.6361 8.5H84.5C86.9853 8.5 89 10.5147 89 13V46.3C89 48.7853 86.9853 50.8 84.5 50.8H39.5C37.0147 50.8 35 48.7853 35 46.3V15.6128C35 14.591 35.3478 13.5996 35.9861 12.8017L37.0028 11.5307L38.1792 10.1192ZM41.6361 10.3C40.8348 10.3 40.0749 10.6559 39.562 11.2715L38.3972 12.6693L37.3917 13.9261C37.0087 14.4049 36.8 14.9997 36.8 15.6128V46.3C36.8 47.7912 38.0088 49 39.5 49H84.5C85.9912 49 87.2 47.7912 87.2 46.3V13C87.2 11.5088 85.9912 10.3 84.5 10.3H41.6361Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon8);
export default __webpack_public_path__ + "static/media/icon8.7192978155c7636bb543cc9964b94b32.svg";
export { ForwardRef as ReactComponent };